import angular from 'angular';

import { isSensitiveKey, redactSensitiveValues, REDACTED } from '../redact';

export const moduleName = 'recaps.services.NewRelic';

const redactArguments = args => Array.prototype.map.call(args, redactSensitiveValues);

// The agent drops arguments past noticeError(error, customAttributes); LogService.error() passes four.
const NOTICE_ERROR_ARITY = 2;

class NewRelicService {
  constructor($window) {
    this.$window = $window;
  }

  get newrelic() {
    return this.$window && (this.$window.NREUM || this.$window.newrelic) || null;
  }

  noticeError(exception, cause) {
    if (this.newrelic && this.newrelic.noticeError) {
      const args = Array.prototype.slice.call(arguments, 0, NOTICE_ERROR_ARITY);
      this.newrelic.noticeError.apply(this.newrelic, redactArguments(args));
    }
  }

  addToTrace(obj) {
    if (this.newrelic && this.newrelic.addToTrace) {
      this.newrelic.addToTrace.apply(this.newrelic, redactArguments(arguments));
    }
  }

  addPageAction(name, attrs) {
    if (this.newrelic && this.newrelic.addPageAction) {
      this.newrelic.addPageAction.apply(this.newrelic, redactArguments(arguments));
    }
  }

  setCustomAttribute(name, value) {
    if (this.newrelic && this.newrelic.setCustomAttribute) {
      // The agent reads a missing or null value as "remove this attribute".
      const args = redactArguments(arguments);
      if (isSensitiveKey(name) && args.length > 1 && args[1] !== null && args[1] !== undefined) {
        args[1] = REDACTED;
      }
      this.newrelic.setCustomAttribute.apply(this.newrelic, args);
    }
  }
}

export const module = angular.module(moduleName, [
]);

module.service('NewRelicService', NewRelicService);

export default module;
